import React, { useEffect, useState } from "react";
import BasicCard from "../BasicCard/BasicCard";
import "./CardHolder.css";

// HOME PAGE
import gifHome1 from "../../assets/gif/landing/global network.gif";
import gifHome2 from "../../assets/gif/landing/user convenience.gif";
import gifHome3 from "../../assets/gif/landing/capital efficiency.gif";

// EDUCATION
import gifEducation1 from "../../assets/school/A section gif/global student base.gif";
import gifEducation2 from "../../assets/school/A section gif/10x more user comfort.gif";
import gifEducation3 from "../../assets/school/A section gif/high resource output.gif";

// OFFICE
import gifOffice1 from "../../assets/office/A section gif/access to  global talent.gif";
import gifOffice2 from "../../assets/office/A section gif/10x more work flexibility.gif";
import gifOffice3 from "../../assets/office/A section gif/minimised  expenditure.gif";

// COMMUNITY
import gifCommunity1 from "../../assets/community/A section gif/access to  global talent.gif";
import gifCommunity2 from "../../assets/community/A section gif/10x more user comfort.gif";
import gifCommunity3 from "../../assets/community/A section gif/minimised  expenditure.gif";

// EVENT
import gifEvent1 from "../../assets/office/A section gif/access to  global talent.gif";
import gifEvent2 from "../../assets/event/A section gifs/10x more attendee comfort.gif";
import gifEvent3 from "../../assets/event/A section gifs/minimised  expenditure.gif";

const CardHolder = ({ page }) => {
  const [cls, setCls] = useState(page);
  const [headline, setHeadline] = useState("");
  const [cardContent, setCardContent] = useState([]);

  useEffect(() => {
    switch (cls) {
      case "home": {
        setHeadline("virtual is an obvious future");
        setCardContent([
          {
            cardCaption: <span id='card-span'>access to <br/> global network</span>,
            src: gifHome1,
          },
          {
            cardCaption: <span id='card-span'>10x more <br /> user convenience</span>,
            src: gifHome2,
          },
          {
            cardCaption: <span id='card-span'>high <br /> capital efficiency</span>,
            src: gifHome3,
          },
        ]);
        break;
      }

      case "education": {
        setHeadline("with revirt you get");
        setCardContent([
          {
            cardCaption: <span id='card-span'>
              global
              <br />
              student base
            </span>,
            src: gifEducation1,
          },
          {
            cardCaption: <span id='card-span'>
              10x more
              <br />
              user comfort
            </span>,
            src: gifEducation2,
          },
          {
            cardCaption:
              <span id='card-span'>
                high
                <br />
                resource output
              </span>,
            src: gifEducation3,
          },
        ]);
        break;
      }

      case "office": {
        setHeadline("with revirt you get");
        setCardContent([
          {
            cardCaption:
              <span id='card-span'>
                access to 
                <br />
                global talent
              </span>,
            src: gifOffice1,
          },
          {
            cardCaption:
              <span id='card-span'>
                10x more
                <br />
                work flexibility
              </span>,
            src: gifOffice2,
          },
          {
            cardCaption:
              <span id='card-span'>
                minimised
                <br />
                expenditure
              </span>,
            src: gifOffice3,
          },
        ]);
        break;
      }

      case "event": {
        setHeadline("with revirt you get");
        setCardContent([
          {
            cardCaption: 
            <span id='card-span'>
              access to
              <br />
              global footprint
            </span>,
            src: gifEvent1,
          },
          {
            cardCaption: 
            <span id='card-span'>
              10x more
              <br />
              attendee comfort
            </span>,
            src: gifEvent2,
          },
          {
            cardCaption: <span id='card-span'>minimised <br/> expenditure</span>,
            src: gifEvent3,
          },
        ]);
        break;
      }

      case "community": {
        setHeadline("with revirt you get");
        setCardContent([
          {
            cardCaption: <span id='card-span'>
              access to<br/>global talent
            </span>,
            src: gifCommunity1,
          },
          {
            cardCaption: <span id='card-span'>
              10x more<br/>user comfort
            </span>,
            src: gifCommunity2,
          },
          {
            cardCaption: <span id='card-span'>
              minimised<br/>expenditure
            </span>,
            src: gifCommunity3,
          },
        ]);
        break;
      }

      default: {
        break;
      }
    }
  }, []);

  return (
    <div className={`section second ${page}Second`}>
      <div className="second-inside container">
        <div className="row justify-content-center">
          <p className="second-heading">{headline}</p>
          {cardContent.map((card, i) => {
            return (
              <div
                className="col-xl-3 col-lg-4 col-md-4 col-sm-12 col-12"
                key={i}
              >
                <BasicCard content={card.cardCaption} image={card.src} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CardHolder;
